/* Copyright 2020 cpke
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by cpke <cryptio@pm.me>, December 2020
 */

import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Alert from "react-bootstrap/Alert";
import { httpClient } from "../request";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { statusToIcon } from "../status";
import "./Register.css";

export default function Register(properties) {
  const [validated, setValidated] = useState(false);

  const [state, setState] = useState({
    username: "",
    email: "",
    password: "",
    license: "",
    password: "",
    result: {
      status: "",
      message: "",
    },
  });

  const handleChange = (e) => {
    const { id, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleRegister = (e) => {
    const form = e.currentTarget;

    const isValid = form.checkValidity();

    e.preventDefault();
    e.stopPropagation();

    setValidated(true);

    if (!isValid) return;

    const data = {
      username: state.username,
      email: state.email,
      password: state.email,
      license: state.license,
      password: state.password,
    };

    httpClient
      .post("/private/register", null, {
        params: data,
      })
      .then((response) => {
        const responseData = response.data;

        if (responseData.status === true) {
          setState({
            username: "",
            email: "",
            password: "",
            license: "",
            password: "",
            result: {
              status: "success",
              message: "Successfully registered",
            },
          });
        } else {
          setState({
            username: "",
            email: "",
            password: "",
            license: "",
            password: "",
            result: {
              status: "danger",
              message: "An unexpected error has occurred",
            },
          });
        }
      })
      .catch((error) => {
        if (error.response) {
          const responseData = error.response.data;

          if ("error" in responseData) {
            // Catch edge cases, usually happens with network errors
            setState({
              username: "",
              email: "",
              password: "",
              license: "",
              password: "",
              result: {
                status: "danger",
                message: responseData.error,
              },
            });
          } else {
            // Catch edge cases, usually happens with network errors
            setState({
              username: "",
              email: "",
              password: "",
              license: "",
              password: "",
              result: {
                status: "danger",
                message: error.message,
              },
            });
          }
        }
      });
  };

  return (
    <div className="Register">
      <div className="container mt-5">
        <div className="row">
          <div className="col-md-4 mx-auto">
            {state.result && (
              <Alert variant={state.result.status}>
                <span className="mr-1">
                  <FontAwesomeIcon icon={statusToIcon[state.result.status]} />
                </span>
                <span>{state.result.message}</span>
              </Alert>
            )}

            <Form noValidate validated={validated} onSubmit={handleRegister}>
              <Form.Group controlId="username">
                <Form.Label>Username</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter username"
                  value={state.username}
                  onChange={handleChange}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  Please enter a username
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group controlId="email">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter email"
                  value={state.email}
                  onChange={handleChange}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  Please enter an email
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group controlId="password">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Enter password"
                  value={state.password}
                  onChange={handleChange}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  Please enter a password
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group controlId="license">
                <Form.Label>License</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter license"
                  value={state.license}
                  onChange={handleChange}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  Please enter a license
                </Form.Control.Feedback>
              </Form.Group>

              <Button variant="primary" type="submit">
                Submit
              </Button>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/containers/Register.js